module.exports = {"FILTER":{"BUTTON":{"SEARCH":"Search","RESET":"Reset","SHOW":"Show","HIDE":"Hide"}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/en/filter.json
// module id = 709
// module chunks = 0